import { sessionKey } from "@service/helpers/sessionHelper";
import { RouteNamesEnum } from "@service/router/RouteNamesEnum";
import store from "@service/store";
import i18 from "@service/locale/i18";
import { Settings } from "luxon";
import { Route } from "vue-router";
import { Session } from "@service/types/Session";
import { parseJson } from "@common/TypesHelper";

const webConferenceRecordingInit = async(to: Route) => {
    await Promise.all([
        store.dispatch('setWebConferenceRecordingEventId', to.params.eventId),
        store.dispatch('onlineUsers/setNeedCounters', false)
    ]);
}

const setLocales = (session: Session) => {
    if (!session.language?.length) { return; }

    i18.locale = session.language;
    Settings.defaultLocale = session.language;
}

export const initSession = async (backend: string, to: Route) => {
    if (store.state.session.sessionId) { return; }

    const storageSession = localStorage.getItem(sessionKey(backend)) || '{}';
    const session = parseJson(storageSession, {}) as Session;

    const needToInitWebConference = to.name == RouteNamesEnum.webConferencesRecording || to.name == RouteNamesEnum.viewMeetingPublicRecording;

    if (needToInitWebConference) {
        await webConferenceRecordingInit(to);
    }

    if (Object.keys(session).length == 0) { return; }

    setLocales(session)

    await store.dispatch('setSession', {data: session, backend: backend});
    await store.dispatch('services/restore', {backend: backend});
    await store.dispatch('fetchInitData', { backend: backend, eventId: to.params.eventId });
}
